"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageTemplating = void 0;
var MessageTemplating = /** @class */ (function () {
    function MessageTemplating() {
    }
    MessageTemplating.process = function (body, dog, profile) {
        return this.processParameters(this.processAlias(body, dog, profile), dog, profile);
    };
    MessageTemplating.processParameters = function (body, dog, profile) {
        var _this = this;
        var newBody = body
            .replace(/\{\{USER_NAME\}\}/g, profile.firstName ? profile.firstName : 'friend')
            .replace(/\{\{DOG_NAME\}\}/g, dog.name ? dog.name : 'your dog')
            .replace(/\{\{DOG_NAME_APS\}\}/g, dog.name ? dog.name + "'s" : 'your dog')
            .replace(/\{\{DOG_PRONOUN\}\}/g, dog.gender === 'MALE' ? 'he' : dog.gender === 'FEMALE' ? 'she' : 'they')
            .replace(/\{\{DOG_PRONOUN_APS\}\}/g, dog.gender === 'MALE' ? 'he\'s' : dog.gender === 'FEMALE' ? 'she\'s' : 'they\'re')
            .replace(/\{\{DOG_PRONOUN_POSSESSIVE\}\}/g, dog.gender === 'MALE' ? 'his' : dog.gender === 'FEMALE' ? 'her' : 'their')
            .replace(/\{\{DOG_PRONOUN_POSSESSIVE_CAP\}\}/g, dog.gender === 'MALE' ? 'His' : dog.gender === 'FEMALE' ? 'Her' : 'Their')
            .replace(/\{\{DOG_PRONOUN_CAP\}\}/g, dog.gender === 'MALE' ? 'He' : dog.gender === 'FEMALE' ? 'She' : 'They')
            .replace(/\{\{DOG_PRONOUN_CAP_APS\}\}/g, dog.gender === 'MALE' ? 'He\'s' : dog.gender === 'FEMALE' ? 'She\'s' : 'They\'re')
            .replace(/\{\{DOG_PRONOUN_OBJ\}\}/g, dog.gender === 'MALE' ? 'him' : dog.gender === 'FEMALE' ? 'her' : 'them')
            .replace(/\{\{DOG_PRONOUN_OBJ_CAP\}\}/g, dog.gender === 'MALE' ? 'Him' : dog.gender === 'FEMALE' ? 'Her' : 'Them')
            .replace(/\{\{DOG_PRONOUN_OBJ_APS\}\}/g, dog.gender === 'MALE' ? 'his' : dog.gender === 'FEMALE' ? 'hers' : 'theirs')
            .replace(/\{\{DOG_PRONOUN_OBJ_POSSESSIVE\}\}/g, dog.gender === 'MALE' ? 'his' : dog.gender === 'FEMALE' ? 'hers' : 'theirs')
            .replace(/\{\{DOG_PRONOUN_OBJ_CAP_APS\}\}/g, dog.gender === 'MALE' ? 'His' : dog.gender === 'FEMALE' ? 'Hers' : 'Theirs')
            .replace(/\{\{DOG_PRONOUN_OBJ_CAP_POSSESSIVE\}\}/g, dog.gender === 'MALE' ? 'His' : dog.gender === 'FEMALE' ? 'Hers' : 'Theirs');
        return newBody
            .split(' ')
            .reduce(function (accumulator, word) {
            var w = word;
            var v = _this.replace(word);
            // Remove words that start with "{{" and end with "}}" so the user doesn't see these mistakes
            if (!!v.match(/^\{\{/) && !!v.match(/\}\}$/)) {
                console.error("Found a mistake: " + word + " was not processed, removing from sentence");
                w = word.replace(/\{\{.*?\}\}/g, '');
            }
            // Avoid adding unnecessary first space
            if (accumulator) {
                return accumulator + " " + w;
            }
            else {
                return w;
            }
        }, '');
    };
    MessageTemplating.processAlias = function (body, dog, profile) {
        var _this = this;
        // id	alias
        // {{USER_NAME}}	Luisa
        // {{DOG_NAME}}	Mila
        // {{DOG_NAME_APS}}	Mila's
        // {{DOG_PRONOUN}}	she
        // {{DOG_PRONOUN_APS}}	she's
        // {{DOG_PRONOUN_POSSESSIVE}}
        // {{DOG_PRONOUN_POSSESSIVE}}
        // {{DOG_PRONOUN_CAP}}	She
        // {{DOG_PRONOUN_CAP_APS}}	She's
        // {{DOG_PRONOUN_OBJ}}	her
        // {{DOG_PRONOUN_OBJ_CAP}}	Her
        // {{DOG_PRONOUN_OBJ_POSSESSIVE}}	hers
        // {{DOG_PRONOUN_OBJ_CAP_POSSESSIVE}}	Hers
        var map = {
            Luisa: '{{USER_NAME}}',
            Mila: '{{DOG_NAME}}',
            'Mila\'s': '{{DOG_NAME_APS}}',
            she: '{{DOG_PRONOUN}}',
            'she\'s': '{{DOG_PRONOUN_APS}}',
            She: '{{DOG_PRONOUN_CAP}}',
            'She\'s': '{{DOG_PRONOUN_CAP_APS}}',
            her: '{{DOG_PRONOUN_OBJ}}',
            Her: '{{DOG_PRONOUN_OBJ_CAP}}',
            hers: '{{DOG_PRONOUN_OBJ_POSSESSIVE}}',
            Hers: '{{DOG_PRONOUN_OBJ_CAP_POSSESSIVE}}'
        };
        var newBody = body.split(' ')
            .reduce(function (accumulator, word) {
            var w = word;
            var _loop_1 = function (key) {
                if (!map.hasOwnProperty(key)) {
                    return "continue";
                }
                var breaks = w.split('\n');
                if (breaks.length > 1) {
                    w = breaks
                        .map(function (ww) {
                        if (key === _this.replace(ww)) {
                            return ww.replace(_this.replace(ww), map[key]);
                        }
                        else {
                            return ww;
                        }
                    })
                        .join('\n');
                }
                else if (key === _this.replace(word)) {
                    w = word.replace(_this.replace(word), map[key]);
                }
            };
            for (var key in map) {
                _loop_1(key);
            }
            // Avoid adding unnecessary first space
            if (accumulator) {
                return accumulator + " " + w;
            }
            else {
                return w;
            }
        }, '');
        return newBody;
    };
    MessageTemplating.replace = function (_w) {
        return _w
            .replace(/[,.!-]/g, '')
            .replace(/\?/g, '')
            .replace(/\;/g, '')
            .replace(/\:/g, '');
    };
    return MessageTemplating;
}());
exports.MessageTemplating = MessageTemplating;
